import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import AnimatedBackground from './components/AnimatedBackground';
import Navbar from './components/Navbar';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Shifts from './pages/Shifts';
import ShiftUpload from './pages/ShiftUpload';
import ShiftView from './pages/ShiftView';
import Admin from './pages/Admin';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import authService from './services/authService';
import './styles/App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <AnimatedBackground />
          <Navbar />
          <Routes>
          <Route
            path="/"
            element={
              authService.isAuthenticated() ?
              <Navigate to="/dashboard" /> :
              <Navigate to="/login" />
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />

          <Route
            path="/shifts"
            element={
              <PrivateRoute>
                <Shifts />
              </PrivateRoute>
            }
          />

          <Route
            path="/shifts/upload"
            element={
              <PrivateRoute>
                <ShiftUpload />
              </PrivateRoute>
            }
          />

          <Route
            path="/shifts/view/:id"
            element={
              <PrivateRoute>
                <ShiftView />
              </PrivateRoute>
            }
          />

          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <Analytics />
              </PrivateRoute>
            }
          />

          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <PrivateRoute adminOnly={true}>
                <Admin />
              </PrivateRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
    </ThemeProvider>
  );
}

export default App;
